import { useState, useEffect } from 'react'
import { StorageFactory } from '@/services'
import { StorageType } from '@/interfaces/storage'

const NOTIFICATION_BADGE_KEY = '__charleston_notification-badge-count'

export const useNotificationBadge = () => {
  const [badgeCount, setBadgeCount] = useState(0)
  const storage = StorageFactory.getStorage(StorageType.LOCAL)

  useEffect(() => {
    const storedCount = storage.getItem<number>(NOTIFICATION_BADGE_KEY)
    if (storedCount !== null) {
      setBadgeCount(storedCount)
    }
  }, [])

  const incrementBadge = () => {
    const newCount = badgeCount + 1
    setBadgeCount(newCount)
    storage.setItem(NOTIFICATION_BADGE_KEY, newCount)
    updateAppBadge(newCount)
  }

  const clearBadge = () => {
    setBadgeCount(0)
    storage.setItem(NOTIFICATION_BADGE_KEY, 0)
    updateAppBadge(0)
  }

  const updateAppBadge = (count: number) => {
    if ('setAppBadge' in navigator) {
      if (count > 0) {
        navigator.setAppBadge(count)
      } else {
        navigator.clearAppBadge()
      }
    }
  }

  return {
    badgeCount,
    incrementBadge,
    clearBadge,
  }
}
